import "../chunk-7B52C2XE.js";
var PopupType = /* @__PURE__ */ ((PopupType2) => {
  PopupType2["SIGN_TRANSACTION_REVIEW"] = "SIGN_TRANSACTION_REVIEW";
  PopupType2["SIGN_MESSAGE_REVIEW"] = "SIGN_MESSAGE_REVIEW";
  PopupType2["LOGIN_PASSKEY"] = "LOGIN_PASSKEY";
  PopupType2["CREATE_PASSKEY"] = "CREATE_PASSKEY";
  PopupType2["OAUTH"] = "OAUTH";
  PopupType2["ON_RAMP_TRANSACTION"] = "ON_RAMP_TRANSACTION";
  return PopupType2;
})(PopupType || {});
export {
  PopupType
};
